import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { JjamesButtonComponent } from 'shared-lib';
import { CoinMachineDto } from '../../../../api/gen';

export interface EmptyCashBoxDialogData {
    machine: CoinMachineDto;
}

/** What the dialog hands back on confirm. */
export interface EmptyCashBoxDialogResult {
    comment: string;
}

/**
 * Confirms that a coin machine's cash box was emptied. The amount is not typed in: the backend books
 * what it counted in the box, which is the figure shown here.
 */
@Component({
    selector: 'app-empty-cash-box-dialog',
    standalone: true,
    imports: [CommonModule, FormsModule, MatDialogModule, MatIconModule, JjamesButtonComponent, TranslatePipe],
    templateUrl: './empty-cash-box-dialog.component.html'
})
export class EmptyCashBoxDialogComponent {
    private dialogRef = inject(MatDialogRef<EmptyCashBoxDialogComponent, EmptyCashBoxDialogResult>);
    readonly data = inject<EmptyCashBoxDialogData>(MAT_DIALOG_DATA);

    readonly comment = signal('');

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm(): void {
        this.dialogRef.close({ comment: this.comment().trim() });
    }
}
